import * as React from 'react'

const useToggleOpen = () => {
  const [open, setOpen] = React.useState<Record<string, boolean>>({})
  const toggleOpen = (name: string) => {
    setOpen((prevOpen) => ({ ...prevOpen, [name]: !prevOpen[name] }))
  }
  return { open, toggleOpen }
}

export default useToggleOpen
